import { render, staticRenderFns } from "./MemberGroupIframe.vue?vue&type=template&id=09e9dc38&"
import script from "./MemberGroupIframe.vue?vue&type=script&lang=ts&"
export * from "./MemberGroupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports